import { render, staticRenderFns } from "./SummaryBarChart.vue?vue&type=template&id=81ed8936"
import script from "./SummaryBarChart.vue?vue&type=script&lang=js"
export * from "./SummaryBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports